import { environment } from '@lla-platform/core/core-util'

export const SCHEDULER_API_URL = {
  getLocationSchedule: `${environment.apiUrl}/locationschedule/get-location-schedule`,
  rejectLocationSchedule: `${environment.apiUrl}/locationschedule/reject-location-schedule`,
  getEmployeesBookedSchedule: `${environment.apiUrl}/locationschedule/get-employees-booked-schedule`,
  setLocationSchedule: `${environment.apiUrl}/locationschedule/set-location-schedule`,
  approveLocationSchedule: `${environment.apiUrl}/locationschedule/approve-location-schedule`,
  getAllLocationSchedules: `${environment.apiUrl}/locationschedule/get-location-schedules`,
  deleteLocationSchedule: (locationScheduleId: string) =>
    `${environment.apiUrl}/locationschedule/delete-location-schedule/${locationScheduleId}`,
  scheduleTemplate: (locationId: string) =>
    `${environment.apiUrl}/admin/location/${locationId}/scheduletemplate`,
  cancelRegionalManagerApproval: `${environment.apiUrl}/locationschedule/cancel-regional-manager-approval`,
  getScheduleAttendance: `${environment.apiUrl}/locationschedule/get-schedule-attendance`
}
